export default __webpack_public_path__ + "static/media/icon.2b265581.svg";